import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Content
export const getConfig = () => api.get("/config").then((r) => r.data);
export const getEvents = (category) =>
  api.get("/events", { params: category ? { category } : {} }).then((r) => r.data);
export const getEvent = (slug) => api.get(`/events/${slug}`).then((r) => r.data);
export const getCourses = (kind) =>
  api.get("/courses", { params: kind ? { kind } : {} }).then((r) => r.data);
export const getCourse = (slug) => api.get(`/courses/${slug}`).then((r) => r.data);
export const getBlog = (category) =>
  api.get("/blog", { params: category ? { category } : {} }).then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getStudio = () => api.get("/studio").then((r) => r.data);
export const getEarn = () => api.get("/earn").then((r) => r.data);
export const getProjects = () => api.get("/projects").then((r) => r.data);
export const getProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getAvailability = (date) => api.get("/studio/availability", { params: { date } }).then((r) => r.data);
export const selfStudyOrder = (body) => api.post("/studio/self-study/order", body).then((r) => r.data);
export const eventHostOrder = (body) => api.post("/studio/event/order", body).then((r) => r.data);
export const membershipSubscribe = (body) => api.post("/membership/subscribe", body).then((r) => r.data);
export const membershipVerify = (body) => api.post("/membership/verify", body).then((r) => r.data);
export const getBooking = (ref) => api.get(`/bookings/${ref}`).then((r) => r.data);

// Forms
export const submitInspiration = (body) => api.post("/forms/inspiration", body).then((r) => r.data);
export const submitWaitlist = (body) => api.post("/forms/waitlist", body).then((r) => r.data);
export const submitCollaborate = (body) => api.post("/forms/collaborate", body).then((r) => r.data);
export const submitContact = (body) => api.post("/forms/contact", body).then((r) => r.data);
export const submitStudioCollaboration = (body) => api.post("/forms/studio-collaboration", body).then((r) => r.data);
export const registerEvent = (slug, body) => api.post(`/events/${slug}/register`, body).then((r) => r.data);
export const enrolCourse = (slug, body) => api.post(`/courses/${slug}/enrol`, body).then((r) => r.data);
export const bookStudio = (body) => api.post("/studio/book", body).then((r) => r.data);

// Payments
export const createOrder = (body) => api.post("/payments/razorpay/order", body).then((r) => r.data);
export const verifyPayment = (body) => api.post("/payments/razorpay/verify", body).then((r) => r.data);

// Member self-service
export const getMyActivity = (email) => api.get("/my/activity", { params: { email } }).then((r) => r.data);
